function eachSeries(series, callback) {
  for (let i = 0; i < series.length; i += 1) {
    callback(series[i], i);
  }
}

function findResetButtonNode(svg) {
  if (!svg) return null;

  const tspans = svg.querySelectorAll('.highcharts-button tspan');
  for (const tspan of tspans) {
    if (tspan.textContent.includes('Reset categories')) {
      return tspan.parentElement?.parentElement || null;
    }
  }

  return null;
}

export const alternateHighchartsLegendClick = function () {
  var seriesIndex = this.index;
  if (this.chart) {
    var series = this.chart.series;

    var allVisible = true;
    eachSeries(series, (entry) => {
      allVisible = allVisible && entry.visible;
    });
    var someVisible = !allVisible;

    if (allVisible) {
      for (var i = 0; i < series.length; i++)
      {
        if (series[i].index != seriesIndex)
        {
          series[i].visible ? series[i].hide() : series[i].show();
        }
      }
      return false;
    }

    if (someVisible) {
      if (!this.visible) {
        return true;
      } else {
        var allOthersHidden = true;
        for (var i = 0; i < series.length; i++)
        {
          if (series[i].index != seriesIndex)
          {
            allOthersHidden = allOthersHidden && !series[i].visible;
          }
        }

        if (allOthersHidden) {
          eachSeries(series, (entry) => {
            entry.show();
          });
          return false;
        }

        return true;
      }
    }
  } else {
    var seriesObject = this.series;
    var series = this.series.points;

    var allVisible = true;
    eachSeries(series, (entry) => {
      allVisible = allVisible && entry.visible;
    });
    var someVisible = !allVisible;

    if (allVisible) {
      for (var i = 0; i < series.length; i++)
      {
        if (series[i].index != seriesIndex)
        {
          series[i].visible ? series[i].setVisible(false) : series[i].setVisible(true);
        }
      }
      setTimeout(function () { seriesObject.chart.adjustPieChartCenterText();}, 0);
      this.setState();

      return false;
    }

    if (someVisible) {
      if (!this.visible) {
        setTimeout(function () { seriesObject.chart.adjustPieChartCenterText();}, 0);
        this.setState();

        return true;
      } else {
        var allOthersHidden = true;
        for (var i = 0; i < series.length; i++)
        {
          if (series[i].index != seriesIndex)
          {
            allOthersHidden = allOthersHidden && !series[i].visible;
          }
        }

        if (allOthersHidden) {
          eachSeries(series, (entry) => {
            entry.setVisible(true);
          });
          setTimeout(function () { seriesObject.chart.adjustPieChartCenterText();}, 0);
          this.setState();

          return false;
        }

        setTimeout(function () { seriesObject.chart.adjustPieChartCenterText();}, 0);
        this.setState();

        return true;
      }
    }
  }
};

var Highcharts = Highcharts || {};

(function(b, a) {
    if (!b) {
        return;
    }
    if (!b.Chart) {
      return;
    }
    var c = b.Chart.prototype,
        d = b.Legend.prototype;
    b.extend(c, {
        legendSetVisibility: function(h) {
            var i = this,
                k = i.legend,
                e, g, j, m = i.options.legend,
                f, l;

            if (m.enabled == h || m.permanentlyDisable) {
                return;
            }

            m.enabled = h;
            if (!h) {
                i.options.exporting.buttons.customButton = {};
                d.destroy.call(k);
                e = k.allItems;
                if (e) {
                    for (g = 0, j = e.length; g < j; ++g) {
                        e[g].legendItem = a;
                    }
                }
                k.group = {};
            }
            c.render.call(i);
            if (!m.floating) {
                f = i.scroller;
                if (f && f.render) {
                    l = i.xAxis[0].getExtremes();
                    f.render(l.min, l.max);
                }
            }
        },
        legendHide: function() {
            if (this.options.chart.type != "treemap") {
                this.legendSetVisibility(false);
                this.resetButtonHide();
            }
        },
        legendShow: function() {
            if (this.options.chart.type != "treemap") {
                this.legendSetVisibility(true);
            }
        },
        legendToggle: function(e) {
            if (typeof e != "boolean") {
                e = (this.options.legend.enabled ^ true);
            }
            this.legendSetVisibility(e);
        },
        findResetButton: function() {
            var renderTarget = this.options.chart.renderTo;
            var svg;
            if (typeof renderTarget === "string") {
              svg = document.querySelector("#" + renderTarget);
            } else {
              svg = renderTarget;
            }
            return findResetButtonNode(svg);
        },
        resetButtonHide: function() {
            var button = this.findResetButton();
            button ? button.style.opacity = 0 : null;
        },
        resetButtonShow: function() {
            var button = this.findResetButton();
            button ? button.style.opacity = 1 : null;
        }
    });
}(Highcharts));
